import React, { useState, useEffect, useRef } from "react";
import Header from "../../Header/Header";
import Footer from "../../Footer/Footer";
import Sticky from "../../stickySide/Sticky";
import Teams from "./Teams";
import Birthday from "./Birthday";
import Getintouch from "./Getintouch";
import Sliders from "./Banner SLider/Sliders";
import { blogs } from "../../Blogs copy/BlogData";
import BlogList from "../../Blogs copy/BlogList";
import Testomonail from "./Testomonial/Testomonail";
import axios from "axios";
import { Link } from "react-router-dom";
import { openGoogleCalendar, downloadIcsFile } from "../../utils/calendarSync";

import {
  FaTimes, FaArrowRight,
} from "react-icons/fa";
import { RiArrowLeftSLine, RiArrowRightSLine } from "react-icons/ri";


import Whyjoinbg from "./Images/whyjoin-background.svg";
import ManImage from "./Images/whyjoinMan.svg";
import welcomeimage from "./Images/welocomeimage.svg";
import connectNowbg from "./Images/connectNowbg.svg";
import counterbg from "./Images/counterbg.svg";
import countericon1 from "./Images/countericon1.svg";
import countericon2 from "./Images/countericon2.svg";
import countericon3 from "./Images/countericon3.svg";
import countericon4 from "./Images/countericon4.svg";
import galleryimage1 from "./Images/galleryimage1.svg";
import galleryimage2 from "./Images/galleryimage2.svg";
import galleryimage3 from "./Images/galleryimage3.svg";
import galleryimage4 from "./Images/galleryimage4.svg";
import galleryimage5 from "./Images/galleryimage5.svg";
import galleryimage6 from "./Images/galleryimage6.svg";
import galleryimage7 from "./Images/galleryimage7.svg";
import galleryimage8 from "./Images/galleryimage8.svg";
import galleryimage9 from "./Images/galleryimage9.svg";
import galleryimage10 from "./Images/galleryimage10.svg";
import galleryimage11 from "./Images/galleryimage11.svg";
import galleryimage12 from "./Images/galleryimage12.svg";
import mediaimage1 from "./Images/mediaimage1.svg";
import mediaimage2 from "./Images/mediaimage2.svg";
import mediaimage3 from "./Images/mediaimage3.svg";
import mediaimage4 from "./Images/mediaimage4.svg";

/* ─── Shared section wrapper styles ─── */
import { useTheme } from "../../context/ThemeContext";

const SECTION_PAD = "py-20 px-4 sm:px-8 lg:px-[8%]";
const INNER      = "max-w-7xl mx-auto";

const Homes = () => {
  const { theme } = useTheme();
  const isLight = theme === "light";

  const BADGE   = `inline-flex items-center gap-1.5 ${isLight ? 'bg-amber-500/10 text-amber-700 border-amber-500/30' : 'bg-[#FDBC12]/10 text-[#FDBC12] border-[#FDBC12]/25'} text-[11px] font-black uppercase px-3.5 py-1 rounded-full border tracking-[0.12em] mb-4`;
  const HEADING = `text-[32px] md:text-[42px] font-black ${isLight ? 'text-[#0A2451]' : 'text-white'} leading-tight`;

  // Dynamic Light / Dark Theme Styling Variables
  const bgSection     = isLight ? "bg-slate-50 text-slate-900 transition-colors duration-300" : "bg-[#07111E] text-slate-100 transition-colors duration-300";
  const bgAltSection  = isLight ? "bg-slate-100/90 text-slate-900 transition-colors duration-300" : "bg-[#0B1525] text-slate-100 transition-colors duration-300";
  const bgGradSection = isLight ? "bg-gradient-to-b from-white via-slate-50 to-slate-100 text-slate-900 transition-colors duration-300" : "bg-gradient-to-b from-[#060D1A] to-[#0B1525] text-slate-100 transition-colors duration-300";
  const bgCard        = isLight ? "bg-white border-slate-200 shadow-lg text-slate-900" : "bg-[#0F1D30] border-slate-800 text-white";
  const textSub       = isLight ? "text-slate-600" : "text-slate-400";

  const [homeSectionsOrder, setHomeSectionsOrder] = useState<any[]>([]);
  const [leaderboard,       setLeaderboard]       = useState<any[]>([]);
  const [newsHeading,       setNewsHeading]        = useState<string>("");
  const [upcomingEvents,    setUpcomingEvents]     = useState<any[]>([]);
  const [featuredVideo,     setFeaturedVideo]      = useState<any | null>(null);

  const [selectedEventModal,          setSelectedEventModal]          = useState<any | null>(null);
  const [activeEvtPhotoIndex,         setActiveEvtPhotoIndex]         = useState<number>(0);
  const [selectedGalleryLightboxImage, setSelectedGalleryLightboxImage] = useState<string | null>(null);
  const [syncingLeaderboard,          setSyncingLeaderboard]          = useState<boolean>(false);

  const leaderSliderRef = useRef<HTMLDivElement>(null);

  const handleSyncLeaderboard = async () => {
    setSyncingLeaderboard(true);
    try {
      const res = await axios.post("https://rmbbackend.rmbjaipur.com/auth/public/sync-leaderboard");
      if (res.data?.success && Array.isArray(res.data.data)) {
        setLeaderboard(res.data.data);
      }
    } catch {
      // Non-fatal catch
    } finally {
      setSyncingLeaderboard(false);
    }
  };

  useEffect(() => {
    axios.get("https://rmbbackend.rmbjaipur.com/auth/home-section-layout")
      .then(res => { if (res.data?.success && Array.isArray(res.data.data)) setHomeSectionsOrder(res.data.data); })
      .catch(()  => {});

    axios.get("https://rmbbackend.rmbjaipur.com/auth/public/leaderboard")
      .then(res => {
        const raw = res.data.data || [];
        setLeaderboard(Array.isArray(raw) ? raw : []);
      })
      .catch(() => {});

    axios.get("https://rmbbackend.rmbjaipur.com/auth/newsheading")
      .then(res => { if (res.data?.data?.[0]?.title) setNewsHeading(res.data.data[0].title); })
      .catch(() => {});

    axios.get("https://rmbbackend.rmbjaipur.com/auth/events")
      .then(res => { const e = res.data.data || res.data || []; setUpcomingEvents(Array.isArray(e) ? e : []); })
      .catch(() => {});

    axios.get("https://rmbbackend.rmbjaipur.com/auth/featured-video")
      .then(res => setFeaturedVideo(res.data.data || null))
      .catch(() => {});
  }, []);

  // Auto-slide leaderboard every 3.5 seconds
  useEffect(() => {
    if (leaderboard.length === 0) return;
    const interval = setInterval(() => {
      if (leaderSliderRef.current) {
        const { scrollLeft, scrollWidth, clientWidth } = leaderSliderRef.current;
        if (scrollLeft + clientWidth >= scrollWidth - 15) {
          leaderSliderRef.current.scrollTo({ left: 0, behavior: "smooth" });
        } else {
          leaderSliderRef.current.scrollBy({ left: 260, behavior: "smooth" });
        }
      }
    }, 3500);

    return () => clearInterval(interval);
  }, [leaderboard]);

  const scroll = (dir: "left" | "right") => {
    leaderSliderRef.current?.scrollBy({ left: dir === "left" ? -260 : 260, behavior: "smooth" });
  };

  const defaultSectionsList = [
    "hero_slider","announcement_ticker","top_rmbians","upcoming_events",
    "latest_blogs","rmbians_meeting","why_join","chapter_vision","chapter_teams",
    "news_media","chapter_gallery","testimonials","connect_cta",
    "impact_stats","featured_video","get_in_touch",
  ];

  const activeHomeSections = homeSectionsOrder.length > 0
    ? [...homeSectionsOrder].sort((a, b) => (a.sort_order || 0) - (b.sort_order || 0))
    : defaultSectionsList.map((k, i) => ({ section_key: k, sort_order: i + 1, is_enabled: 1 }));

  /* ═══════════════════════ RENDER SECTION BY KEY ═══════════════════════ */
  const renderSectionByKey = (key: string, sec?: any): React.ReactNode => {
    switch (key) {

      /* ── HERO SLIDER ─────────────────────────────────────────────────── */
      case "hero_slider":
        return <Sliders key="hero_slider" />;

      /* ── ANNOUNCEMENT TICKER ─────────────────────────────────────────── */
      case "announcement_ticker":
        return newsHeading ? (
          <div key="announcement_ticker"
            className="bg-gradient-to-r from-[#0A1527] via-[#0C1D3A] to-[#0A1527] border-y border-[#FDBC12]/30 py-3 px-4 sm:px-8 overflow-hidden">
            <div className="max-w-7xl mx-auto flex items-center gap-4">
              <span className="flex-shrink-0 bg-[#FDBC12] text-[#0A2451] font-black text-[10px] uppercase px-3 py-1.5 rounded-lg tracking-widest shadow">
                📢 LIVE
              </span>
              <div className="flex-1 overflow-hidden relative">
                <div
                  className="whitespace-nowrap text-amber-300 text-sm font-semibold"
                  style={{ animation: "ticker 28s linear infinite" }}
                >
                  {newsHeading}&nbsp;&nbsp;&nbsp;&nbsp;•&nbsp;&nbsp;&nbsp;&nbsp;{newsHeading}
                </div>
              </div>
            </div>
            <style>{`
              @keyframes ticker {
                0%   { transform: translateX(60%); }
                100% { transform: translateX(-100%); }
              }
            `}</style>
          </div>
        ) : null;

      /* ── TOP RMBIANS LEADERBOARD ─────────────────────────────────────── */
      case "top_rmbians":
        const top10Leaderboard = leaderboard.slice(0, 10);
        return (
          <section key="top_rmbians"
            className={`${SECTION_PAD} ${bgGradSection}`}>
            <div className={INNER}>

              {/* Header Row */}
              <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-10">
                <div>
                  <span className={BADGE}>🏆 Top 10 Leaderboard</span>
                  <h2 className={HEADING}>
                    Top 10 <span className="text-[#FDBC12]">RMBians</span> by Points
                  </h2>
                  <p className={`${textSub} text-sm mt-2`}>
                    Celebrating the top 10 most active Rotarians and business leaders of the month
                  </p>
                </div>
                <div className="flex items-center gap-2 pb-1">
                  <button
                    onClick={handleSyncLeaderboard}
                    disabled={syncingLeaderboard}
                    className="flex items-center gap-1.5 px-3 py-2 rounded-xl bg-[#FDBC12]/10 border border-[#FDBC12]/30 hover:bg-[#FDBC12] text-[#FDBC12] hover:text-[#0A2451] text-xs font-black transition cursor-pointer disabled:opacity-50"
                    title="Sync Latest Points & Standings"
                  >
                    <span className={syncingLeaderboard ? "animate-spin" : ""}>🔄</span>
                    <span>{syncingLeaderboard ? "Syncing..." : "Sync Standings"}</span>
                  </button>
                  <button onClick={() => scroll("left")}
                    className={`w-10 h-10 rounded-full border ${isLight ? 'border-slate-300 hover:bg-slate-200 text-slate-700' : 'border-slate-700 hover:border-[#FDBC12] hover:bg-[#FDBC12]/10 text-slate-300 hover:text-[#FDBC12]'} flex items-center justify-center transition cursor-pointer`}>
                    <RiArrowLeftSLine size={20} />
                  </button>
                  <button onClick={() => scroll("right")}
                    className={`w-10 h-10 rounded-full border ${isLight ? 'border-slate-300 hover:bg-slate-200 text-slate-700' : 'border-slate-700 hover:border-[#FDBC12] hover:bg-[#FDBC12]/10 text-slate-300 hover:text-[#FDBC12]'} flex items-center justify-center transition cursor-pointer`}>
                    <RiArrowRightSLine size={20} />
                  </button>
                </div>
              </div>

              {/* Cards Slider / Carousel (Snap Slider so cards never cut off or stay half-visible) */}
              {top10Leaderboard.length === 0 ? (
                <div className={`text-center ${bgCard} border rounded-3xl p-12 text-slate-400 font-medium`}>
                  Loading top 10 RMBian leaderboard...
                </div>
              ) : (
                <div className="relative">
                  <div
                    ref={leaderSliderRef}
                    className="flex gap-5 overflow-x-auto py-4 px-1 scroll-smooth snap-x snap-mandatory"
                    style={{ scrollbarWidth: "none", msOverflowStyle: "none" }}
                  >
                    {top10Leaderboard.map((user: any, index: number) => {
                      const medalColors = [
                        "from-amber-500/20 to-amber-700/5 border-amber-400/60 ring-1 ring-amber-400/30",
                        "from-slate-400/20 to-slate-500/5 border-slate-400/50 ring-1 ring-slate-400/20",
                        "from-orange-600/20 to-orange-700/5 border-orange-500/50 ring-1 ring-orange-400/20",
                      ];
                      const medalEmoji = ["🥇","🥈","🥉"];
                      const isTop3 = index < 3;

                      const cleanedImg = user.profile
                        ? (user.profile.startsWith("http")
                            ? user.profile
                            : `https://rmbbackend.rmbjaipur.com/${user.profile.replace(/\\/g, "/").replace(/^\//, "")}`)
                        : `https://ui-avatars.com/api/?name=${encodeURIComponent(user.name || "Member")}&background=0A2451&color=FDBC12`;

                      return (
                        <div
                          key={user.id || index}
                          className={`flex-shrink-0 w-56 sm:w-60 snap-start flex flex-col items-center ${
                            isTop3 ? `bg-gradient-to-b ${medalColors[index]}` : (isLight ? "bg-white border-slate-200 shadow-xl text-slate-900" : "bg-gradient-to-b from-[#111C2E] to-[#0D1629] border-slate-800/80 text-white")
                          } border rounded-3xl p-6 transition-all duration-300 hover:-translate-y-1.5 hover:shadow-2xl relative group`}
                        >
                          {/* Rank Badge */}
                          <div className="absolute top-4 left-4">
                            {isTop3 ? (
                              <span className="text-2xl shadow-md">{medalEmoji[index]}</span>
                            ) : (
                              <span className="text-[10px] font-black text-amber-500 bg-amber-500/10 border border-amber-500/30 px-2.5 py-0.5 rounded-full">
                                Rank #{index + 1}
                              </span>
                            )}
                          </div>

                          {/* Avatar */}
                          <div className={`w-22 h-22 rounded-full overflow-hidden border-2 ${
                            isTop3 ? "border-[#FDBC12]" : "border-slate-400 dark:border-slate-700"
                          } shadow-xl mt-3 mb-3 group-hover:scale-105 transition-transform duration-300 bg-slate-900`}>
                            <img
                              src={cleanedImg}
                              alt={user.name}
                              className="w-full h-full object-cover"
                              onError={(e) => {
                                e.currentTarget.src = `https://ui-avatars.com/api/?name=${encodeURIComponent(user.name || "Member")}&background=0A2451&color=FDBC12`;
                              }}
                            />
                          </div>

                          {/* Info */}
                          <div className="text-center w-full space-y-1 my-1 flex-1 flex flex-col justify-center min-w-0">
                            <h4 className={`font-black text-base line-clamp-1 ${isLight ? 'text-slate-900' : 'text-white'}`}>{user.name}</h4>
                            <p className="text-[#FDBC12] text-xs font-bold line-clamp-1">
                              {user.designation || "RMB Member"}
                            </p>
                            <p className={`${textSub} text-xs font-medium line-clamp-1`}>
                              {user.company_name || "Jaipur Chapter"}
                            </p>
                          </div>

                          {/* Points Badge */}
                          <div className="w-full mt-4 pt-3.5 border-t border-slate-200 dark:border-slate-800/80 flex items-center justify-center gap-1.5">
                            <span className="text-[#FDBC12] text-sm">✪</span>
                            <span className="text-[#FDBC12] font-black text-sm">{user.point || 0} Points</span>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              )}
            </div>
          </section>
        );

      /* ── UPCOMING EVENTS ─────────────────────────────────────────────── */
      case "upcoming_events":
        return (
          <section key="upcoming_events" className={`${SECTION_PAD} ${bgSection}`}>
            <div className={INNER}>

              <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-12">
                <div>
                  <span className={BADGE}>🗓️ Chapter Events</span>
                  <h2 className={HEADING}>
                    Upcoming <span className="text-[#FDBC12]">Meetings & Events</span>
                  </h2>
                  <p className={`${textSub} text-sm mt-2 max-w-lg`}>
                    Join our fellowship meetings, business presentations, and networking visits.
                  </p>
                </div>
                <Link to="/meetings">
                  <button className="flex items-center gap-2 bg-[#FDBC12] hover:bg-amber-400 text-[#0A2451] px-5 py-2.5 rounded-xl font-black text-xs shadow-lg transition cursor-pointer whitespace-nowrap">
                    View All Meetings <FaArrowRight />
                  </button>
                </Link>
              </div>

              {upcomingEvents.length === 0 ? (
                <div className={`text-center border border-dashed ${isLight ? 'border-slate-300' : 'border-slate-800'} rounded-3xl p-16 max-w-lg mx-auto`}>
                  <div className="text-5xl mb-4">🗓️</div>
                  <h3 className={`text-lg font-bold ${isLight ? 'text-slate-900' : 'text-white'} mb-2`}>No Upcoming Meetings Yet</h3>
                  <p className={`${textSub} text-sm`}>Check back soon for upcoming chapter events.</p>
                </div>
              ) : (
                <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6">
                  {upcomingEvents.slice(0, 3).map((event: any) => {
                    let evtImg = 'https://ui-avatars.com/api/?name=Event&background=0A2451&color=FDBC12';
                    const rawPhotos = event.photographs || event.photos || event.image || event.img;
                    if (rawPhotos) {
                      try {
                        const parsed = typeof rawPhotos === 'string' ? JSON.parse(rawPhotos) : rawPhotos;
                        if (Array.isArray(parsed) && parsed.length > 0) evtImg = parsed[0];
                        else if (typeof rawPhotos === 'string' && rawPhotos.includes('&')) evtImg = rawPhotos.split('&')[0];
                        else if (typeof rawPhotos === 'string') evtImg = rawPhotos;
                      } catch {
                        if (typeof rawPhotos === 'string' && rawPhotos.includes('&')) evtImg = rawPhotos.split('&')[0];
                        else if (typeof rawPhotos === 'string') evtImg = rawPhotos;
                      }
                    }
                    const cleanedEvtImg = evtImg.startsWith('http')
                      ? evtImg
                      : `https://rmbbackend.rmbjaipur.com/${evtImg.replace(/\\/g, '/').replace(/^\//, '')}`;

                    return (
                      <div
                        key={event.id}
                        className={`group ${bgCard} border hover:border-[#FDBC12]/50 rounded-2xl p-5 flex flex-col justify-between shadow-xl transition-all duration-300 hover:-translate-y-1 hover:shadow-2xl overflow-hidden`}
                      >
                        <div>
                          {/* Event Image Banner - 100% uncropped with ambient blurred backdrop */}
                          <div
                            className={`w-full h-48 rounded-xl overflow-hidden mb-4 ${isLight ? 'bg-slate-100 border-slate-200' : 'bg-[#0A1527] border-slate-700/60'} border cursor-pointer relative group/img flex items-center justify-center`}
                            onClick={() => { setSelectedEventModal(event); setActiveEvtPhotoIndex(0); }}
                          >
                            {/* Ambient Blurred Background Fill */}
                            <img
                              src={cleanedEvtImg}
                              alt=""
                              className="absolute inset-0 w-full h-full object-cover blur-xl opacity-30 scale-110"
                              aria-hidden="true"
                            />

                            {/* Main Uncropped Image */}
                            <img
                              src={cleanedEvtImg}
                              alt={event.heading || 'Event'}
                              className="relative z-10 max-h-full max-w-full object-contain p-1 group-hover/img:scale-105 transition-transform duration-500 shadow-md"
                              onError={(e) => {
                                e.currentTarget.src = 'https://ui-avatars.com/api/?name=Event&background=0A2451&color=FDBC12';
                              }}
                            />

                            {/* Event Type Badge */}
                            <div className="absolute top-3 left-3 z-20 bg-[#FDBC12] text-[#0A2451] text-[10px] font-black uppercase px-2.5 py-1 rounded-full shadow-lg border border-amber-300/40">
                              {event.event_type || 'General Meeting'}
                            </div>
                          </div>

                          <div className="flex items-center justify-between text-xs mb-2">
                            <span className={`${textSub} font-semibold flex items-center gap-1`}>
                              📅 {event.event_date
                                ? new Date(event.event_date).toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" })
                                : "TBD"}
                            </span>
                            {event.location && (
                              <span className="text-[#FDBC12] font-semibold text-[11px] line-clamp-1 max-w-[150px]">
                                📍 {event.location}
                              </span>
                            )}
                          </div>

                          <h3
                            className={`text-base font-bold ${isLight ? 'text-slate-900 group-hover:text-amber-600' : 'text-white group-hover:text-[#FDBC12]'} transition-colors cursor-pointer`}
                            onClick={() => { setSelectedEventModal(event); setActiveEvtPhotoIndex(0); }}
                          >
                            {event.heading || event.description || "Chapter Fellowship Meeting"}
                          </h3>

                          {event.description && (
                            <p className={`text-xs ${textSub} line-clamp-2 leading-relaxed mt-2`}>
                              {event.description}
                            </p>
                          )}
                        </div>

                        <div className={`pt-4 border-t ${isLight ? 'border-slate-200' : 'border-slate-800/80'} flex items-center justify-between gap-2 mt-4`}>
                          <button
                            type="button"
                            onClick={() => { setSelectedEventModal(event); setActiveEvtPhotoIndex(0); }}
                            className={`text-xs font-bold ${isLight ? 'text-slate-700 hover:text-slate-900' : 'text-slate-300 hover:text-white'} flex items-center gap-1.5 cursor-pointer transition-colors`}
                          >
                            View Details <FaArrowRight size={10} />
                          </button>

                          <div className="flex items-center gap-1.5">
                            <button
                              type="button"
                              onClick={() => openGoogleCalendar({
                                title: event.heading || event.description || 'RMB Chapter Meeting',
                                date: event.event_date,
                                location: event.location || 'Jaipur',
                                description: event.description
                              })}
                              className={`${isLight ? 'bg-slate-100 hover:bg-slate-200 text-amber-700 border-amber-500/40' : 'bg-slate-800 hover:bg-slate-700 text-amber-400 border-amber-400/30'} border px-2.5 py-1.5 rounded-xl text-xs font-bold transition cursor-pointer flex items-center gap-1`}
                              title="Sync Event Date to Google Calendar for Reminders"
                            >
                              📅 Sync
                            </button>

                            <Link to={`/rsvp/${event.id || 'general'}`}>
                              <button
                                type="button"
                                className="bg-[#FDBC12] hover:bg-amber-400 text-[#0A2451] px-3.5 py-1.5 rounded-xl font-black text-xs shadow-md transition cursor-pointer flex items-center gap-1"
                              >
                                🎟️ Attend
                              </button>
                            </Link>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          </section>
        );

      /* ── LATEST BLOGS ────────────────────────────────────────────────── */
      case "latest_blogs":
        return (
          <section key="latest_blogs" className={`${SECTION_PAD} bg-[#0B1525]`}>
            <div className={INNER}>
              <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-10">
                <div>
                  <span className={BADGE}>📰 Blog & News</span>
                  <h2 className={HEADING}>
                    Learn About Our <span className="text-[#FDBC12]">Latest News</span>
                  </h2>
                </div>
                <Link to="/blogs">
                  <button className="flex items-center gap-2 border border-[#FDBC12]/40 text-[#FDBC12] hover:bg-[#FDBC12] hover:text-[#0A2451] px-5 py-2.5 rounded-xl font-bold text-xs transition cursor-pointer whitespace-nowrap">
                    View All <FaArrowRight size={11} />
                  </button>
                </Link>
              </div>
              <BlogList blogs={blogs} limit={3} />
            </div>
          </section>
        );

      /* ── RMBIANS MEETING / BIRTHDAYS ─────────────────────────────────── */
      case "rmbians_meeting":
        return <Birthday key="rmbians_meeting" />;

      /* ── WHY JOIN ────────────────────────────────────────────────────── */
      case "why_join":
        return (
          <section
            key="why_join"
            className="relative overflow-hidden py-20 px-4 sm:px-8 lg:px-[8%]"
            style={{ backgroundImage: `url(${Whyjoinbg})`, backgroundSize: "cover", backgroundPosition: "center" }}
          >
            {/* Overlay */}
            <div className="absolute inset-0 bg-gradient-to-r from-[#020810]/95 via-[#020810]/80 to-[#020810]/40" />

            <div className="max-w-7xl mx-auto relative z-10 flex flex-col lg:flex-row items-center gap-16">
              {/* Left Text */}
              <div className="lg:w-[55%] w-full">
                <span className={BADGE}>✦ Membership Benefits</span>
                <h2 className="text-[36px] md:text-[48px] font-black text-white leading-tight mb-10">
                  Why You Must Join<br />
                  <span className="text-[#FDBC12]">RMB Jaipur?</span>
                </h2>

                <div className="space-y-7">
                  {[
                    {
                      n: "01",
                      t: "Trusted Rotarian Network",
                      d: "RMB unites Rotarians with shared values of integrity and service — creating a high-trust environment where business thrives organically.",
                    },
                    {
                      n: "02",
                      t: "Accelerated Professional Growth",
                      d: "Access structured referral exchanges, B2B networking, and knowledge-sharing sessions with top industry leaders across Jaipur.",
                    },
                    {
                      n: "03",
                      t: "Impactful Community Service",
                      d: "Combine commercial success with humanitarian causes — grow your business while giving back to the community.",
                    },
                  ].map(b => (
                    <div key={b.n} className="flex gap-5">
                      <div className="flex-shrink-0 w-10 h-10 rounded-xl bg-[#FDBC12]/10 border border-[#FDBC12]/30 flex items-center justify-center">
                        <span className="text-[#FDBC12] font-black text-sm">{b.n}</span>
                      </div>
                      <div>
                        <h3 className="text-white font-bold text-base mb-1">{b.t}</h3>
                        <p className="text-slate-400 text-sm leading-relaxed">{b.d}</p>
                      </div>
                    </div>
                  ))}
                </div>

                <a href="/about" className="inline-block mt-10">
                  <button className="bg-[#FDBC12] hover:bg-amber-400 text-[#0A2451] px-8 py-3.5 rounded-xl font-black text-sm shadow-2xl shadow-amber-500/20 transition duration-300 cursor-pointer">
                    Discover More Benefits →
                  </button>
                </a>
              </div>

              {/* Right Image */}
              <div className="lg:w-[45%] w-full flex justify-center">
                <div className="relative">
                  <div className="absolute -inset-4 bg-[#FDBC12]/10 rounded-3xl blur-2xl" />
                  <img
                    src={ManImage}
                    alt="Join RMB Jaipur"
                    className="relative max-h-[500px] w-auto object-contain drop-shadow-2xl"
                  />
                </div>
              </div>
            </div>
          </section>
        );

      /* ── CHAPTER VISION ──────────────────────────────────────────────── */
      case "chapter_vision":
        return (
          <section key="chapter_vision" className={`${SECTION_PAD} bg-[#0B1525]`}>
            <div className={INNER}>
              <div className="text-center mb-12">
                <span className={BADGE}>🤝 About Us</span>
                <h2 className={`${HEADING} max-w-3xl mx-auto`}>
                  Welcome to{" "}
                  <span className="text-[#FDBC12]">Rotary Means Business</span>{" "}
                  Fellowship Jaipur
                </h2>
                <p className="text-slate-400 text-base mt-5 max-w-2xl mx-auto leading-relaxed">
                  Rotary Means Business encourages Rotarians and Non-Rotarians to support
                  the success of fellow members by doing business directly and extending
                  quality business referrals.
                </p>
              </div>

              <div className="relative max-w-5xl mx-auto rounded-3xl overflow-hidden shadow-2xl border border-white/5">
                <img
                  src={welcomeimage}
                  alt="RMB Fellowship Jaipur"
                  className="w-full h-[300px] sm:h-[480px] object-cover"
                />
                {/* Gradient overlay at bottom */}
                <div className="absolute inset-x-0 bottom-0 h-24 bg-gradient-to-t from-[#0B1525] to-transparent" />
              </div>
            </div>
          </section>
        );

      /* ── CHAPTER TEAMS ───────────────────────────────────────────────── */
      case "chapter_teams":
        return <Teams key="chapter_teams" />;

      /* ── NEWS & MEDIA ────────────────────────────────────────────────── */
      case "news_media":
        return (
          <section key="news_media" className={`${SECTION_PAD} ${bgGradSection}`}>
            <div className={INNER}>
              <div className="mb-12">
                <span className={BADGE}>📡 Press Room</span>
                <h2 className={HEADING}>
                  RMB News &amp; <span className="text-[#FDBC12]">Media</span>
                </h2>
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
                {[
                  { img: mediaimage1, label: "News Channel" },
                  { img: mediaimage2, label: "Print Media" },
                  { img: mediaimage3, label: "Radio Media" },
                  { img: mediaimage4, label: "Other News" },
                ].map(m => (
                  <div
                    key={m.label}
                    className={`group ${bgCard} border hover:border-[#FDBC12]/50 rounded-2xl p-6 flex flex-col items-center gap-4 text-center transition-all duration-300 hover:-translate-y-1 hover:shadow-xl cursor-pointer`}
                  >
                    <div className="w-16 h-16 flex items-center justify-center">
                      <img src={m.img} alt={m.label} className="w-14 h-14 object-contain" />
                    </div>
                    <h3 className={`font-bold text-base ${isLight ? 'text-slate-900' : 'text-white'}`}>{m.label}</h3>
                    <button className="w-full py-2 rounded-xl bg-[#FDBC12]/10 border border-[#FDBC12]/20 text-[#FDBC12] text-xs font-bold group-hover:bg-[#FDBC12] group-hover:text-[#0A2451] transition">
                      Click Here
                    </button>
                  </div>
                ))}
              </div>
            </div>
          </section>
        );

      /* ── CHAPTER GALLERY ─────────────────────────────────────────────── */
      case "chapter_gallery":
        return (
          <section key="chapter_gallery" className={`${SECTION_PAD} ${bgSection}`}>
            <div className={INNER}>
              <div className="mb-10">
                <span className={BADGE}>📷 Photo Gallery</span>
                <h2 className={HEADING}>
                  Chapter Event <span className="text-[#FDBC12]">Gallery</span>
                </h2>
              </div>

              <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-3">
                {[galleryimage1,galleryimage2,galleryimage3,galleryimage4,galleryimage5,galleryimage6,
                  galleryimage7,galleryimage8,galleryimage9,galleryimage10,galleryimage11,galleryimage12
                ].map((img, i) => (
                  <div
                    key={i}
                    onClick={() => setSelectedGalleryLightboxImage(img)}
                    className="relative aspect-square rounded-xl overflow-hidden border border-white/5 cursor-pointer group shadow-lg"
                  >
                    <img
                      src={img}
                      alt={`Gallery ${i + 1}`}
                      className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent opacity-0 group-hover:opacity-100 transition-opacity flex items-end justify-center pb-2">
                      <span className="text-white text-[10px] font-bold">🔍 View</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </section>
        );

      /* ── TESTIMONIALS ────────────────────────────────────────────────── */
      case "testimonials":
        return <Testomonail key="testimonials" />;

      /* ── CONNECT CTA ─────────────────────────────────────────────────── */
      case "connect_cta":
        return (
          <section
            key="connect_cta"
            className="relative py-24 px-4 sm:px-8 lg:px-[8%] overflow-hidden"
            style={{ backgroundImage: `url(${connectNowbg})`, backgroundSize: "cover", backgroundPosition: "center" }}
          >
            <div className="absolute inset-0 bg-gradient-to-r from-[#0A2451]/95 via-[#0A2451]/80 to-[#02256D]/75" />

            <div className="max-w-7xl mx-auto relative z-10 flex flex-col lg:flex-row items-center justify-between gap-10">
              <div className="max-w-2xl">
                <span className={BADGE}>🚀 Join RMB Jaipur</span>
                <h2 className="text-[34px] md:text-[46px] font-black text-white leading-tight">
                  Become Part of a<br />
                  <span className="text-[#FDBC12]">Global Business Network</span>
                </h2>
                <p className="text-slate-300 text-base mt-4 leading-relaxed max-w-lg">
                  Dedicated to mutual success, service, and sustainable business growth with 200+ chapters worldwide.
                </p>
              </div>
              <a href="/contact">
                <button className="flex-shrink-0 bg-[#FDBC12] hover:bg-amber-400 text-[#0A2451] px-10 py-4 rounded-2xl font-black text-base shadow-2xl shadow-amber-500/30 transition duration-300 cursor-pointer">
                  Connect Now →
                </button>
              </a>
            </div>
          </section>
        );

      /* ── IMPACT STATS ────────────────────────────────────────────────── */
      case "impact_stats":
        const impactBg = sec?.bg_image ? sec.bg_image : welcomeimage;
        return (
          <section
            key="impact_stats"
            className="relative py-24 px-4 sm:px-8 lg:px-[8%] overflow-hidden"
            style={{ backgroundImage: `url(${impactBg})`, backgroundSize: "cover", backgroundPosition: "center" }}
          >
            {/* Rich Dark Gradient & Glass Overlay */}
            <div className="absolute inset-0 bg-gradient-to-r from-[#030814]/95 via-[#0A1C3B]/90 to-[#030814]/95 backdrop-blur-[2px]" />

            <div className="max-w-7xl mx-auto relative z-10">
              <div className="text-center mb-14">
                <span className={BADGE}>📊 Our Impact</span>
                <h2 className={HEADING}>
                  Numbers That <span className="text-[#FDBC12]">Speak</span>
                </h2>
              </div>

              <div className="grid grid-cols-2 lg:grid-cols-4 gap-6">
                {[
                  { icon: countericon1, val: "200+", lbl: "Chapters Worldwide" },
                  { icon: countericon2, val: "80+",  lbl: "Chapters in India" },
                  { icon: countericon3, val: "24+",  lbl: "Annual Meetings" },
                  { icon: countericon4, val: "₹10Cr+", lbl: "Closed Business" },
                ].map(s => (
                  <div
                    key={s.lbl}
                    className="group bg-gradient-to-b from-[#101F38]/80 to-[#0A1527]/90 border border-slate-700/60 hover:border-[#FDBC12] rounded-3xl p-8 flex flex-col items-center gap-4 text-center transition-all duration-300 hover:-translate-y-1.5 hover:shadow-2xl hover:shadow-[#FDBC12]/20 backdrop-blur-md"
                  >
                    <div className="w-16 h-16 rounded-2xl bg-[#FDBC12]/10 border border-[#FDBC12]/25 flex items-center justify-center p-3 group-hover:scale-110 transition-transform duration-300 shadow-inner">
                      <img src={s.icon} alt={s.lbl} className="w-full h-full object-contain" />
                    </div>
                    <div className="text-[#FDBC12] text-4xl font-black tracking-tight">{s.val}</div>
                    <div className="text-slate-300 text-sm font-bold leading-snug">{s.lbl}</div>
                  </div>
                ))}
              </div>
            </div>
          </section>
        );

      /* ── FEATURED VIDEO ──────────────────────────────────────────────── */
      case "featured_video":
        return featuredVideo?.video_url ? (
          <section key="featured_video" className={`${SECTION_PAD} ${bgSection}`}>
            <div className={`${INNER} text-center`}>
              <span className={BADGE}>🎬 Featured Video</span>
              <h2 className={`${HEADING} max-w-3xl mx-auto mb-4`}>
                {featuredVideo.title || "Discover Rotary Means Business Fellowship Jaipur"}
              </h2>
              {featuredVideo.description && (
                <p className={`${textSub} text-sm max-w-xl mx-auto mb-10 leading-relaxed`}>
                  {featuredVideo.description}
                </p>
              )}
              <div className="relative aspect-video max-w-4xl mx-auto rounded-3xl overflow-hidden border border-[#FDBC12]/20 shadow-2xl shadow-amber-500/10">
                <iframe
                  src={featuredVideo.video_url.includes("watch?v=")
                    ? featuredVideo.video_url.replace("watch?v=", "embed/")
                    : featuredVideo.video_url}
                  title="RMB Featured Video"
                  className="w-full h-full border-0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                />
              </div>
            </div>
          </section>
        ) : null;

      /* ── GET IN TOUCH ────────────────────────────────────────────────── */
      case "get_in_touch":
        return <Getintouch key="get_in_touch" />;

      default:
        return null;
    }
  };

  /* ═══════════════════════ MAIN RENDER ═══════════════════════════════════ */
  return (
    <div className={isLight ? "bg-slate-100 text-slate-900 min-h-screen transition-colors duration-300" : "bg-[#07111E] text-slate-100 min-h-screen transition-colors duration-300"}>
      <Header />
      <Sticky />

      {activeHomeSections.map((sec: any) =>
        sec.is_enabled === 0 ? null : renderSectionByKey(sec.section_key, sec)
      )}

      <Footer />

      {/* ── Event Detail Modal ───────────────────────────── */}
      {selectedEventModal && (
        <div className="fixed inset-0 z-50 bg-black/80 backdrop-blur-md flex items-center justify-center p-4">
          <div className={`${isLight ? 'bg-white border-slate-200 text-slate-900' : 'bg-[#0F1D30] border-slate-700 text-white'} border rounded-3xl max-w-lg w-full shadow-2xl overflow-hidden`}>
            {/* Modal Header */}
            <div className="flex items-start justify-between p-6 border-b border-slate-800">
              <div>
                <span className="text-[10px] font-black uppercase tracking-wider text-[#FDBC12] bg-[#FDBC12]/10 border border-[#FDBC12]/20 px-2.5 py-1 rounded-full">
                  🗓️ Event Details
                </span>
                <h2 className="text-lg font-black text-white mt-2 leading-snug">
                  {selectedEventModal.heading || selectedEventModal.description || "Chapter Meeting"}
                </h2>
              </div>
              <button
                onClick={() => setSelectedEventModal(null)}
                className="ml-4 p-2 text-slate-400 hover:text-white hover:bg-slate-800 rounded-xl transition cursor-pointer flex-shrink-0"
              >
                <FaTimes size={16} />
              </button>
            </div>

            {/* Modal Body */}
            <div className="p-6 space-y-4">
              <div className="bg-[#070D18] border border-slate-800 rounded-2xl p-4">
                <h4 className="text-[#FDBC12] text-[11px] font-black uppercase mb-2">📝 Description & Agenda</h4>
                <p className="text-slate-300 text-sm leading-relaxed whitespace-pre-line">
                  {selectedEventModal.description || "Regular Chapter Meeting & Networking Event."}
                </p>
              </div>

              {/* Sync Calendar & Notifications Box */}
              <div className="bg-[#07111E] border border-amber-400/25 rounded-2xl p-4 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
                <div>
                  <h4 className="text-white text-xs font-black flex items-center gap-1.5">
                    📅 Calendar Sync & Reminders
                  </h4>
                  <p className="text-slate-400 text-[11px] mt-0.5">
                    Sync event date to receive device notification reminders before the meeting.
                  </p>
                </div>

                <div className="flex items-center gap-2 self-stretch sm:self-auto justify-end">
                  <button
                    type="button"
                    onClick={() => openGoogleCalendar({
                      title: selectedEventModal.heading || selectedEventModal.description || 'RMB Chapter Meeting',
                      date: selectedEventModal.event_date,
                      location: selectedEventModal.location || 'Jaipur',
                      description: selectedEventModal.description
                    })}
                    className="bg-[#FDBC12]/10 hover:bg-[#FDBC12] text-[#FDBC12] hover:text-[#0A2451] border border-[#FDBC12]/30 px-3 py-1.5 rounded-xl text-xs font-black transition cursor-pointer whitespace-nowrap"
                  >
                    Google Calendar
                  </button>

                  <button
                    type="button"
                    onClick={() => downloadIcsFile({
                      title: selectedEventModal.heading || selectedEventModal.description || 'RMB Chapter Meeting',
                      date: selectedEventModal.event_date,
                      location: selectedEventModal.location || 'Jaipur',
                      description: selectedEventModal.description
                    })}
                    className="bg-slate-800 hover:bg-slate-700 text-slate-200 border border-slate-700 px-3 py-1.5 rounded-xl text-xs font-bold transition cursor-pointer whitespace-nowrap"
                  >
                    iCal / Outlook
                  </button>
                </div>
              </div>
            </div>

            <div className="px-6 pb-6 flex items-center justify-between gap-3">
              <Link to={`/rsvp/${selectedEventModal.id || 'general'}`}>
                <button
                  type="button"
                  className="px-5 py-2.5 bg-[#FDBC12] hover:bg-amber-400 text-[#0A2451] font-black text-xs rounded-xl shadow-lg cursor-pointer transition flex items-center gap-1.5"
                >
                  🎟️ Register & Attend Event
                </button>
              </Link>
              <button
                onClick={() => setSelectedEventModal(null)}
                className="px-6 py-2.5 bg-slate-800 hover:bg-slate-700 text-slate-200 font-bold text-xs rounded-xl cursor-pointer transition"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ── Gallery Lightbox ─────────────────────────────── */}
      {selectedGalleryLightboxImage && (
        <div
          className="fixed inset-0 bg-black/95 backdrop-blur-md flex items-center justify-center z-50 p-4"
          onClick={() => setSelectedGalleryLightboxImage(null)}
        >
          <button
            className="absolute top-5 right-5 bg-white/10 hover:bg-rose-600 rounded-full w-10 h-10 flex items-center justify-center text-white text-xl font-black transition cursor-pointer"
            onClick={() => setSelectedGalleryLightboxImage(null)}
          >
            ×
          </button>
          <img
            src={selectedGalleryLightboxImage}
            alt="Gallery Fullscreen"
            className="max-h-[90vh] max-w-full object-contain rounded-2xl shadow-2xl"
            onClick={e => e.stopPropagation()}
          />
        </div>
      )}
    </div>
  );
};

export default Homes;
